import { Box, CircularProgress } from '@material-ui/core';
import { DefaultCard } from 'design-system';

export const LoadingContent = (): JSX.Element => {
  return (
    <Box sx={{ textAlign: 'center', py: '2rem' }}>
      <CircularProgress />
      <br />
      Espere unos segundos...
    </Box>
  );
};

export const Loading = (): JSX.Element => {
  return (
    <DefaultCard
      width="100%"
      cardStyles={{
        margin: '0 auto',
      }}
    >
      <LoadingContent />
    </DefaultCard>
  );
};
